<template>
  <div class="dropdown-widget">
    <div class="dual-inputs">
      <div class="input operand-drop-down">
        <AutoComplete
          :items="column.suffixes"
          filled
          dense
          class="input-md app-drop-down mb-3"
          active
          item-value="operand"
          item-text="operand"
          autocomplete="off"
          v-model="selected"
          :tabindex="2"
          @change="handleOnChangeOperand"
        />
      </div>
      <div class="input auto-complete">
        <v-autocomplete
          ref="teamsInputSearch"
          :items="column.options"
          outlined
          v-model="value"
          focus
          dense
          multiple
          item-text="name"
          item-id="id"
          return-object
          tabindex="2"
          @change="handleOnValueChange"
        >
          <template v-slot:item="{ item }">
            <div class="auto-complete-item"> {{ item }} </div>
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip close @click:close="handleOnRemoveTeam(index)" v-if="index < numberOfVisibleTags">
              <LimitedText :text="item" classes="selected-location" :max-length="8" />
            </v-chip>
            <span v-if="index === numberOfVisibleTags" class="grey--text caption">
              (+{{ selectedCount - numberOfVisibleTags }} {{ $t("others") }})
            </span>
          </template>
        </v-autocomplete>
      </div>
    </div>
  </div>
</template>
<script>
import { $eventHub } from "@/components";
import { EventConstraints } from "@/enums/events.enum";
export default {
  name: "MultipleDropDownWidget",

  data() {
    return {
      selected: [],
      value: "",
    };
  },

  props: {
    operands: {
      type: Array,
      default: () => [],
    },
    widget: {
      type: Object,
      default: () => {},
    },
    column: {
      type: Object,
      default: () => {},
    },
    option: {
      type: Object,
      default: () => {},
    },
    numberOfVisibleTags: {
      type: Number,
      default: 2,
    },
  },

  mounted() {
    this.value = this.column?.value || "";
    this.selected = this.widget.operand;
  },

  watch: {
    value: {
      immediate: true,
      handle(value) {
        value ? (widget.state = WIDGETS_STATE.FILLED) : WIDGETS_STATE.EXPANDED;
      },
    },
  },

  computed: {
    selectedCount() {
      return this.value.length;
    },
  },

  methods: {
    /**
     *unselect all and assign newly selected
     * @return {void}
     */
    handleOnChangeOperand() {
      this.column.selectOperand(this.selected);
    },

    /**
     * will handle changing the value search
     * @return {void}
     */
    handleOnValueChange() {
      this.column.value = this.value;
    },
  },
};
</script>
